/* eslint-disable react/prop-types */
import { orderServingStatsApi } from "@/api/take-order/take-order";
import { setOrderData } from "@/redux/slice/take-order-slice/order-slice";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";

function FoodServingStatus({ isTabletView }) {
    const { orderData: order } = useSelector((state) => state.takeOrder.order); useSelector
    const dispatch = useDispatch();

    const stage = ["pending", "on_going", "completed"];

    function getNextStage(currentStage) {
        const currentIndex = stage.indexOf(currentStage);
        if (currentIndex === -1) {
            return stage[0];
        }
        return stage[(currentIndex + 1) % stage.length];
    }

    function updateServingStatus(status, nextStage = "on_going") {
        // API call to update serving status
        console.log("Update Serving Status to:", status);

        orderServingStatsApi(order?.id, {
            category_key: status,
            stage: nextStage
        }).then((res) => {
            if (res.status === "success") {
                // toast message with category and stage
                toast.success(getToolTipText(nextStage, status));
                dispatch(setOrderData(res.data));
            } else {
                toast.error(res.message || "Failed to update serving status");
            }
        });
    }

    console.log("Order in FoodServingStatus:", order);

    function getToolTipText(stage, category) {
        if (stage === "pending") {
            return `Need to serve ${category}`;
        } else if (stage === "on_going") {
            return `${category} is being served`;
        } else if (stage === "completed") {
            return `${category} has been completed`;
        }
    }

    return (
        <div className={` border-2 border-color3 ${isTabletView ? "mt-1.5 p-1.5 text-sm" : "mt-2 p-2"} flex gap-4 justify-between`}>
            {
                order?.category_stage?.drinks != null &&
                    <button title={getToolTipText(order?.category_stage?.drinks, "Drinks")} onClick={()=> updateServingStatus("drinks", getNextStage(order?.category_stage?.drinks))} className=" bg-color3 py-1 px-2 grow text-color5 rounded-md relative">
                        <span>Drinks</span>
                        {
                            order?.category_stage?.drinks == "pending" &&
                            <div className=" absolute top-0 right-0 w-4 h-4 bg-color6 rounded-full"></div>
                        }
                        {
                            order?.category_stage?.drinks == "on_going" &&
                            <>
                                <div className=" absolute top-0 right-0 w-4 h-4 bg-color7 rounded-full"></div>
                                <div className=" absolute top-0 right-0 w-4 h-4 bg-color7 rounded-full animate-ping"></div>
                            </>
                        }
                        {
                            order?.category_stage?.drinks == "completed" &&
                            <div className=" absolute top-0 right-0 w-4 h-4 bg-red-600 rounded-full"></div>
                        }
                        
                    </button>
            }

            {
                order?.category_stage?.foods != null &&
                    <button title={getToolTipText(order?.category_stage?.foods, "Foods")} onClick={()=> updateServingStatus("foods", getNextStage(order?.category_stage?.foods))} className=" bg-color3 py-1 px-2 grow text-color5 rounded-md relative">
                        <span>Foods</span>
                        {
                            order?.category_stage?.foods == "pending" &&
                            <div className=" absolute top-0 right-0 w-4 h-4 bg-color6 rounded-full"></div>
                        }
                        {
                            order?.category_stage?.foods == "on_going" &&
                            <>
                                <div className=" absolute top-0 right-0 w-4 h-4 bg-color7 rounded-full"></div>
                                <div className=" absolute top-0 right-0 w-4 h-4 bg-color7 rounded-full animate-ping"></div>
                            </>
                        }
                        {
                            order?.category_stage?.foods == "completed" &&
                            <div className=" absolute top-0 right-0 w-4 h-4 bg-red-600 rounded-full"></div>
                        }
                    </button>
            }
            {
                order?.category_stage?.dessert != null &&
                    <button title={getToolTipText(order?.category_stage?.dessert, "Dessert")} onClick={()=> updateServingStatus("dessert", getNextStage(order?.category_stage?.dessert))} className=" bg-color3 py-1 px-2 grow text-color5 rounded-md relative">
                        <span>Dessert</span>
                        {
                            order?.category_stage?.dessert == "pending" &&
                            <div className=" absolute top-0 right-0 w-4 h-4 bg-color6 rounded-full"></div>
                        }
                        {
                            order?.category_stage?.dessert == "on_going" &&
                            <>
                                <div className=" absolute top-0 right-0 w-4 h-4 bg-color7 rounded-full"></div>
                                <div className=" absolute top-0 right-0 w-4 h-4 bg-color7 rounded-full animate-ping"></div>
                            </>
                        }
                        {
                            order?.category_stage?.dessert == "completed" &&
                            <div className=" absolute top-0 right-0 w-4 h-4 bg-red-600 rounded-full"></div>
                        }
                    </button>
            }
            {
                order?.category_stage?.tea_coffee != null &&
                    <button title={getToolTipText(order?.category_stage?.tea_coffee, "Tea & Coffee")} onClick={()=> updateServingStatus("tea_coffee", getNextStage(order?.category_stage?.tea_coffee))} className=" bg-color3 py-1 px-2 grow text-color5 rounded-md relative">
                        <span>Tea & Coffee</span>
                        {
                            order?.category_stage?.tea_coffee == "pending" &&
                            <div className=" absolute top-0 right-0 w-4 h-4 bg-color6 rounded-full"></div>
                        }
                        {
                            order?.category_stage?.tea_coffee == "on_going" &&
                            <>
                                <div className=" absolute top-0 right-0 w-4 h-4 bg-color7 rounded-full"></div>
                                <div className=" absolute top-0 right-0 w-4 h-4 bg-color7 rounded-full animate-ping"></div>
                            </>
                        }
                        {
                            order?.category_stage?.tea_coffee == "completed" &&
                            <div className=" absolute top-0 right-0 w-4 h-4 bg-color8 rounded-full"></div>
                        }
                    </button>
            }
        </div>
    )
}


export default FoodServingStatus;